<ng-container *transloco="let tr; prefix: 'productDefinitions.media'; scope: 'product-definitions'">
  <div class="tile" [class.first]="tile().main && tile().state !== 'failed'" [class.err]="tile().state === 'failed'" [class.over]="dropOver()" [class.is-busy]="busy()">
    <div class="ph" [title]="hint()">
      <hc-media-thumb [thumb]="tile().thumb" [kind]="tile().kind"></hc-media-thumb>
      @if (movable()) {
        <span class="handle" [attr.title]="tr('tile.drag')"><hc-media-icon name="handle" [size]="14"></hc-media-icon></span>
      }
      <span class="pos">{{ tile().index + 1 }}</span>
      @if (tile().kind === 'VIDEO' && tile().state !== 'failed') {
        <span class="play" aria-hidden="true"><hc-media-icon name="play" [size]="18"></hc-media-icon></span>
        @if (duration()) {
          <span class="dur">{{ duration() }}</span>
        }
      }
      @if (tile().main && tile().state !== 'failed') {
        <span class="main-tag"><hc-media-icon name="star" [size]="11"></hc-media-icon>{{ tr('tile.main') }}</span>
      }

      @switch (tile().state) {
        @case ('queued') {
          <div class="ov">
            <span class="pct">{{ tr('tile.queued') }}</span>
          </div>
        }
        @case ('uploading') {
          <div class="ov">
            <span class="pct">{{ tile().percent }} %</span>
            <div class="bar"><span [style.width.%]="tile().percent"></span></div>
            <span class="small">{{ sentText() }}</span>
          </div>
        }
        @case ('interrupted') {
          <div class="ov">
            <span class="pct">{{ tr('tile.interrupted') }}</span>
            <span class="small">{{ tr('tile.interruptedHint') }}</span>
          </div>
        }
        @case ('processing') {
          <div class="ov" [class.dark]="tile().kind === 'VIDEO'">
            <span class="spin" aria-hidden="true"></span>
            <span>{{ tr('tile.preparing.' + tile().kind) }}</span>
            <span class="small">{{ tr('tile.preparingHint.' + tile().kind) }}</span>
          </div>
        }
        @case ('delayed') {
          <div class="ov" [class.dark]="tile().kind === 'VIDEO'">
            <hc-media-icon name="info" [size]="22"></hc-media-icon>
            <span>{{ tr('tile.delayed') }}</span>
            <span class="small">{{ tr('tile.delayedHint') }}</span>
          </div>
        }
      }

      @if (tile().replacement; as r) {
        <div class="repl" [class.bad]="r.state === 'failed'">
          @if (r.state === 'uploading' || r.state === 'processing') {
            <span class="spin tiny" aria-hidden="true"></span>
          }
          <span class="repl-text">{{ replacementText() }}</span>
          @if (editable() && r.state === 'failed' && r.canRetry) {
            <button type="button" class="lnk" [disabled]="busy()" (click)="retryReplacement.emit()">{{ tr('tile.retry') }}</button>
          }
          @if (editable() && r.state !== 'uploading') {
            <button type="button" class="lnk" [disabled]="busy()" (click)="cancelReplacement.emit()">{{ tr('tile.cancelReplace') }}</button>
          }
        </div>
      }
    </div>

    <span class="meta" [class.bad-text]="tile().state === 'failed'"><b>{{ kindWord() }}</b>@if (info()) { · {{ info() }} }</span>
    @if (tile().warnLowRes && tile().state !== 'failed') {
      <span class="warnline"><hc-media-icon name="info" [size]="12"></hc-media-icon>{{ tr('tile.lowRes') }}</span>
    }

    @if (editable()) {
      @if (movable()) {
        <div class="acts">
          <button class="ib" type="button" [attr.aria-label]="tr('tile.left')" [disabled]="tile().index === 0" (click)="moveLeft.emit()"><hc-media-icon name="left" [size]="12" [width]="2.4"></hc-media-icon></button>
          <button class="ib" type="button" [attr.aria-label]="tr('tile.right')" [disabled]="last()" (click)="moveRight.emit()"><hc-media-icon name="right" [size]="12" [width]="2.4"></hc-media-icon></button>
          <button class="ib more" type="button" nz-dropdown nzTrigger="click" nzPlacement="bottomRight" [nzDropdownMenu]="menu" [attr.aria-label]="tr('tile.more')"><hc-media-icon name="more" [size]="14"></hc-media-icon></button>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu class="tile-menu">
              <li nz-menu-item [nzDisabled]="!tile().canFrame" (click)="frame.emit()">
                <hc-media-icon name="frame" [size]="14"></hc-media-icon>
                <span>{{ tile().canFrame ? tr('tile.frame.' + tile().kind) : tr('tile.frameWait') }}</span>
              </li>
              <li nz-menu-item [nzDisabled]="!!tile().replacement" (click)="replace.emit()">
                <hc-media-icon name="replace" [size]="14"></hc-media-icon>
                <span>{{ tr('tile.replaceFile') }}</span>
              </li>
              <li nz-menu-item nzDanger (click)="remove.emit()">
                <hc-media-icon name="trash" [size]="14"></hc-media-icon>
                <span>{{ tr('tile.delete') }}</span>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
      }

      <div class="links">
        @switch (tile().state) {
          @case ('queued') {
            <button type="button" class="lnk" (click)="cancelUpload.emit()">{{ tr('tile.cancel') }}</button>
          }
          @case ('uploading') {
            <button type="button" class="lnk" (click)="cancelUpload.emit()">{{ tr('tile.cancel') }}</button>
          }
          @case ('interrupted') {
            <button type="button" class="lnk bad" [disabled]="busy()" (click)="remove.emit()">{{ tr('tile.delete') }}</button>
          }
          @case ('failed') {
            @if (tile().uploadFailure !== null) {
              <button type="button" class="lnk" [disabled]="busy()" (click)="retryUpload.emit()">{{ tr('tile.retryUpload') }}</button>
            } @else if (tile().canRetry) {
              <button type="button" class="lnk" [disabled]="busy()" (click)="retry.emit()">{{ tr('tile.retry') }}</button>
            }
            @if (tile().id !== null) {
              <button type="button" class="lnk bad" [disabled]="busy()" (click)="remove.emit()">{{ tr('tile.delete') }}</button>
            } @else {
              <button type="button" class="lnk bad" (click)="cancelUpload.emit()">{{ tr('tile.delete') }}</button>
            }
          }
          @default {
            @if (tile().state === 'processing' || tile().state === 'delayed') {
              <button type="button" class="lnk" [disabled]="!tile().canFrame || busy()" (click)="frame.emit()">{{ tile().canFrame ? tr('tile.frame.' + tile().kind) : tr('tile.frameWait') }}</button>
            } @else if (!tile().main) {
              <button type="button" class="lnk" [disabled]="busy() || orderBusy()" (click)="makeMain.emit()">{{ tr('tile.makeMain') }}</button>
            } @else {
              <span class="muted">{{ tr('tile.mainWhere') }}</span>
            }
          }
        }
      </div>
    }
  </div>
</ng-container>
